import VladislavK from 'assets/illustrations/specialistsAvatars/vladislavK.png';
import OlgaV from 'assets/illustrations/specialistsAvatars/olgaV.png';
import Alexey3 from 'assets/illustrations/specialistsAvatars/alexey3.png';
import SergeyP from 'assets/illustrations/specialistsAvatars/sergeyP.png';
import AndreyM from 'assets/illustrations/specialistsAvatars/andreyM.png';
import ValeriaL from 'assets/illustrations/specialistsAvatars/valeriaL.png';
import MaximT from 'assets/illustrations/specialistsAvatars/maximT.png';
import SvetlanaV from 'assets/illustrations/specialistsAvatars/svetlanaV.png';

export const specialistCardsData = [
  {
    avatar: VladislavK,
    name: 'Владислав К.',
    position: 'Senior Java Developer',
    description:
      'Опыт — 7 лет. Придерживается чистоты архитектуры и следует лучшим практикам и принципам. ',
    skills: ['Java', 'Spring', 'MySQL', 'JUnit', 'Mockito', 'SQL'],
    popoverSkills: [
      'Java',
      'Spring',
      'MySQL',
      'JUnit',
      'Mockito',
      'SQL',
      'Spring Test',
      'Liquibase',
      'PostgreSQL',
      'Testcontainers',
      'AssertJ',
    ],
  },
  {
    avatar: OlgaV,
    name: 'Ольга В.',
    position: 'Senior System Analyst',
    description: 'Опыт более 5 лет на e-commerce, enterprise-проектах, а также в сфере финтеха.',
    skills: ['REST API', 'UML', 'PostgreSQL', 'Figma', 'BPMN'],
    popoverSkills: [
      'REST API',
      'UML',
      'PostgreSQL',
      'Figma',
      'BPMN',
      'Apache Kafka',
      'DrawSQL',
      'Postman',
    ],
  },
  {
    avatar: Alexey3,
    name: 'Алексей З.',
    position: 'Senior DevOps Engineer',
    description:
      'Опыт — 9 лет. Владеет широким спектром технологий, включая AWS, Kubernetes, Jenkins, GitLab.',
    skills: ['AWS', 'Docker', 'Kubernetes', 'Istio', 'Helm', 'Jenkins'],
    popoverSkills: [
      'AWS',
      'Docker',
      'Kubernetes',
      'Istio',
      'Helm',
      'Jenkins',
      'Bitbucket',
      'Bitrise',
      'GitLab',
      'GitHub Actions',
      'Grafana',
      'VMWare',
      'Proxmox',
      'Terraform',
      'Ansible',
      'Ansistrano',
      'Apache',
      'Nginx',
    ],
  },
  {
    avatar: SergeyP,
    name: 'Сергей П.',
    position: 'Senior Front-end Developer',
    description: 'Имеет опыт более 6 лет в создании различных типов высококачественных проектов.',
    skills: ['JavaScript', 'PHP', 'React', 'HTML', 'CSS', 'Redux'],
    popoverSkills: [
      'JavaScript',
      'PHP',
      'React',
      'HTML',
      'CSS',
      'Redux',
      'Material-UI',
      'Flow',
      'Webpack',
      'Twig',
    ],
  },
  {
    avatar: AndreyM,
    name: 'Андрей М.',
    position: '.NET Developer',
    description: '.NET developer с 6 летним опытом разработки программного обеспечения.',
    skills: ['.NET', 'ASP.NET', '.NET Framework', 'Angular', 'SQL'],
    popoverSkills: [
      '.NET',
      'ASP.NET',
      '.NET Framework',
      'Angular',
      'SQL',
      'PostgreSQL',
      'MS SQL',
      'NUnit',
      'Fluent Assertions',
      'REST API',
      'Docker',
      'RabbitMQ',
      'Apache Kafka',
      'Swagger',
      'Postman',
      'SMTP',
      'Kubernetes',
    ],
  },
  {
    avatar: ValeriaL,
    name: 'Валерия Л.',
    position: 'Senior QA Engineer',
    description: 'Имеет опыт планирования тестирования, создания тестов и составления отчетов.',
    skills: ['Zephyr', 'Zeplin', 'TestRail', 'iTools', 'Swagger', 'Xray'],
    popoverSkills: [
      'Zephyr',
      'Zeplin',
      'TestRail',
      'iTools',
      'Swagger',
      'Xray',
      'Postman',
      'Charles',
      'REST API',
      'PostgreSQL',
      'DBeaver',
      'Android Studio',
      'Chrome DevTools',
    ],
  },
  {
    avatar: MaximT,
    name: 'Максим Т.',
    position: 'Senior iOS Developer',
    description: 'Senior iOS Developer с 5-летним опытом разработки мобильных приложений.',
    skills: ['Swift', 'Objective-C', 'CocoaPods', 'iOS SDK', 'SPM'],
    popoverSkills: [
      'Swift',
      'Objective-C',
      'CocoaPods',
      'iOS SDK',
      'SPM',
      'Ruby',
      'macOS SDK',
      'Alamofire',
      'RxSwift',
      'CoreData',
      'DITranquillity',
      'UIKit',
      'SwiftUI',
      'Storyboards',
      'Async/Await',
      'MVC',
      'MVVM',
      'VIPER',
      'Clean Swift',
      'Clean Architecture',
      'Carthage',
      'Fastlane',
    ],
  },
  {
    avatar: SvetlanaV,
    name: 'Светлана В.',
    position: 'Agile Project Manager',
    description: 'Опыт — 5 лет. Эффективно ведет команды к успешной реализации проектов.',
    skills: ['Agile', 'Waterfall', 'Jira', 'Redmine', 'Worksection'],
    popoverSkills: [
      'Agile (Scrum, Kanban, XP)',
      'Waterfall',
      'Jira',
      'Redmine',
      'Worksection',
      'Azure DevOps',
      'TestRail',
      'GitLab',
      'GitHub',
    ],
  },
];
